<template>
  <NotFound v-if="typeCheck === 'error'" />
  <main class="main-content-area" v-else v-observer:subtree="mutationObserve">
    <!-- Game banner section -->
    <section class="">
      <template
        v-if="
          (pageBlockData1 && pageBlockData1.length > 0) ||
          (pageBlockData2 && pageBlockData2.length > 0) ||
          (pageBlockData3 && pageBlockData3.length > 0)
        "
      >
        <div v-for="(block, index1) in pageBlockData1" :key="`fi+${index1}`">
          <div
            class="banner-section pt-26"
            v-if="block.blockName === 'header_section'"
          >
            <div
              class="img-wrapper"
              :style="{
                background: `url('${
                  block.data.image ? block.data.image : ''
                }'), ${$root.color_schema.primary}`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }"
            ></div>
            <div class="container">
              <!--Breadcrumps-->
              <div class="col-md-12" v-if="breadcrumb && breadcrumb.length > 0">
                <Breadcrumb
                  :breadcrumbData="breadcrumb"
                  :dark="getContrastYIQ($root.color_schema.primary)"
                />
              </div>
              <!--End Breadcrumps-->
              <div class="banner-section-content">
                <div class="text_content">
                  <label> “{{ block.data.text }}” </label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="values-section"
            v-else-if="
              block.blockName === 'values_section' &&
              Object.keys(block.data.items).length > 0
            "
          >
            <div class="container">
              <h2 class="values-header">{{ $root.i18n.our_values }}</h2>
              <div class="row values-blocks">
                <div
                  class="col-md-4"
                  v-for="(val, indx) in block.data.items"
                  :key="indx"
                >
                  <div class="values-blocks-item text-center">
                    <span class="value-icon">
                      <img :src="val.icon" :alt="getAltText('', val.icon)"
                    /></span>
                    <h2>{{ val.title }}</h2>
                    <p>
                      {{ val.text }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="fundamental-section editor-content"
            v-else-if="block.blockName === 'fundamentals_section'"
          >
            <div
              class="fundamental-img-wrapper"
              :style="{
                background: `url('${
                  block.data.background_image ? block.data.background_image : ''
                }')`,
                backgroundColor: '#f2d93700',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }"
            ></div>
            <div class="container">
              <div class="fundamental-block">
                <div class="fundamental-block-logo">
                  <img
                    :src="block.data.logo"
                    :alt="getAltText('', block.data.logo)"
                  />
                </div>
                <div class="fundamental-block-cont">
                  <h2 class="header">{{ $root.i18n.our_fundamentals }}</h2>
                  <div
                    :class="{
                      'tick-div-green':
                        block.data.list_style === 'green' &&
                        block.data.list_content.indexOf('ul') > 0,
                      'tick-div-blue':
                        block.data.list_style === 'blue' &&
                        block.data.list_content.indexOf('ul') > 0,
                    }"
                    v-html="block.data.list_content"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="{ 'custom-background-image': $root.color_schema.site_bg_img }"
          :style="{
            '--bg-image': `url(${$root.color_schema.site_bg_img}) repeat`,
            '--bg-color': $root.color_schema.site_bg_color,
          }"
        >
          <a
            class="main-tag cas-link"
            :href="getGoLink($root.goto_link, $root.slug)"
            v-if="$root.color_schema.site_bg_img"
            target="_blank"
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
          ></a>
          <div
            :class="{
              'custom-background-color': $root.color_schema.site_bg_img,
              'pb-25': pageBlockData2.length > 0,
              'pt-26': !pageBlockData1,
            }"
          >
            <section
              v-if="pageBlockData2.length > 0"
              :class="{ 'ct-card-horizontal-game': pageBlockData1 }"
            >
              <template v-for="(data, index) in pageBlockData2">
                <CustomComponent :key="`${data.blockName}-${index}`" 
                  :blockData="data" 
                  :recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
                  :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
                  :blockIndex="index"
                  />
              </template>
              <!--Author Block-->
              <template
                v-if="
                  auhtorBlockdata && pageBlockData2.length === blockData2.length
                "
              >
              </template>
              <!--End Author Block-->
            </section>
          </div>
        </div>
        <div v-for="(block, index3) in pageBlockData3" :key="`th+${index3}`">
          <div
            class="team-section"
            v-if="
              block.blockName === 'teams_section' &&
              Object.keys(block.data.teams).length > 0
            "
          >
            <div class="container">
              <h2 class="team-header">{{ $root.i18n.our_teams }}</h2>
              <div class="team-blocks">
                <div
                  class="team-item"
                  v-for="(team, intm) in block.data.teams"
                  :key="intm"
                >
                  <div class="team-pic">
                    <img
                      :src="team.user.user_avatar_url"
                      :alt="getAltText('', team.user.user_avatar_url)"
                    />
                  </div>
                  <h4 class="tm-title">{{ team.user.display_name }}</h4>
                  <p class="department">{{ team.role_title }}</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="timeline-section"
            v-else-if="
              block.blockName === 'timeline_section' &&
              Object.keys(block.data.timelines).length > 0
            "
            :style="{
              background: `url('${
                block.data.background_image ? block.data.background_image : ''
              }'), ${
                block.data.background_color && block.data.background_color != ''
                  ? block.data.background_color
                  : $root.color_schema.primary
              }`,
            }"
          >
            <div class="container">
              <h2 class="timeline-header">{{ $root.i18n.our_timeline }}</h2>
              <ul class="timeline-block">
                <li
                  v-for="(timeline, timein) in block.data.timelines"
                  :key="timein"
                  :style="{
                    '--li-color': block.data.timeline_color,
                    '--primary-color': $root.color_schema.footer_bg,
                  }"
                >
                  <span class="date">{{ timeline.date }}</span>
                  <h4>{{ timeline.title }}</h4>
                  <p>
                    {{ timeline.text }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </section>
    <!-- End Game banner section -->
  </main>
</template>

<script>
import CustomComponent from '@/components/CustomComponent';
import Breadcrumb from "@/components/layouts/Breadcrumb";
import RelatedLinks from "@/components/custom-block/RelatedLinks";
import NotFound from "@/pages/404";
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";
import { metaChanger } from "@/misc/meta-changer";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "AboutUs",
  props: ["aboutUsData"],
  components: {
    Breadcrumb,
    CustomComponent,
    RelatedLinks,
    NotFound,
  },
  data: function () {
    return {
      diposit: true,
      showMorePros: false,
      withdraw: true,
      showPros: true,
      pageData: {
        type: Array,
        default: () => [],
      },
      top_block: {
        type: Object,
        default: () => {},
      },
      diposit_withdraw: {
        type: Array,
        default: () => [],
      },
      diposit_only: {
        type: Array,
        default: () => [],
      },
      withdraw_only: {
        type: Array,
        default: () => [],
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      breadcrumb: {
        type: Array,
        default: () => [],
      },
      top_block: {
        type: Object,
        default: () => {},
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      blockData1: [],
      blockData2: [],
      blockData3: [],
      pageBlockData1: [],
      pageBlockData2: [],
      pageBlockData3: [],
      block1Index: 0,
      block2Index: 0,
      block3Index: 0,
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      endOfblockData: false,
      hideBonusLabel: false,
      hideToplistLabel: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      typeCheck: "",
      bluebar: {},
    };
  },
  methods: {
    pSBC,
    getContrastYIQ,
    metaChanger,
    getOffset,
    showProConsTab: function () {
      this.showPros = !this.showPros;
    },
    getPageData: function () {
      HttpService.getBody(
        this.$root.wp_country && this.$root.wp_country != ""
          ? this.$root.wp_country
          : this.$cookies.get("wp-country"),
        this.$root.wp_state && this.$root.wp_state != ""
          ? this.$root.wp_state
          : this.$cookies.get("wp-state"),
        this.$route.params.postSlug,
        this.$root.user_id
      )
        .then(
          (res) => {
            this.blockData1 = [];
            this.blockData3 = [];
            const res_data = res.data.data;
            this.blockData2 = res_data.content.blocks;
            Object.keys(res_data.meta).forEach((key) => {
              if (
                key != "more_payment_method" &&
                key != "teams_section" &&
                key != "timeline_section"
              )
                this.blockData1.push({
                  blockName: key,
                  data: res_data.meta[key],
                });
            });

            Object.keys(res_data.meta).forEach((key1) => {
              if (key1 === "teams_section" || key1 === "timeline_section")
                this.blockData3.push({
                  blockName: key1,
                  data: res_data.meta[key1],
                });
            });

            // Assets Sizes
            this.assets_images =
              Object.keys(this.$root.asset_sizes).length > 0
                ? this.$root.asset_sizes
                : "";

            // More Payments Bottom Card
            this.morePaymentBottom = res_data.meta.more_payment_method;

            // Author Blocks Filtered
            let atBlock = this.blockData2.filter((ele) => {
              if (ele.blockName === "wpvcb/author-block") {
                return ele.filtered_content;
              }
            });
            if (atBlock.length > 0)
              this.auhtorBlockdata = atBlock.shift().filtered_content;

            // RightContent Blocks Filtered
            let rightBlock = res_data.content.blocks.filter((ele) => {
              if (ele.blockName === "wpvcb/right-content-simpletoc") {
                return ele.filtered_content;
              }
            });
            if (rightBlock.length > 0)
              this.rightBlockdata = rightBlock.shift().filtered_content;

            // Breadcrumb
            this.breadcrumb = res_data.breadcrumb;

            // Adminbar Data
            this.$root.adminBarData =
              Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
            this.$root.disable = this.$root.adminBarData
              ? this.$root.adminBarData.visible
              : false;

            // Schema Append
            document.getElementById("schema-script").innerHTML =
              res_data.schema;

            //this.getBonusShowHide(this.top_section);
          },
          (err) => console.log(err),
          () => {
            // if (!this.$root.enable_lazyload) {
            this.pageBlockData1 = this.blockData1;
            this.pageBlockData2 = this.blockData2;
            this.$root.show_footer = true;
            this.$root.body_loading_status = true;
            // } else {
            // if (Object.keys(this.blockData1).length > 0) {
            //   this.pageBlockData1.push(this.blockData1[this.block1Index]);
            //   this.block1Index++;
            //   this.$root.show_footer = false;
            // } else {
            //   this.$root.show_footer = true;
            // }
            //}
          }
        )
        .catch((err) => {
          this.typeCheck = "error";
          this.$root.loading = false;
        });
    },
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function (mutations) {
      if (
        this.pageBlockData1.length < this.blockData1.length ||
        this.pageBlockData2.length < this.blockData2.length ||
        this.pageBlockData3.length < this.blockData3.length
      ) {
        if (this.pageBlockData1.length < this.blockData1.length) {
          let mainContentArea =
            this.getOffset(mutations[0].target).top +
            mutations[0].target.offsetHeight;
          if (mainContentArea < window.innerHeight) {
            //this.incrementBlockDataValue();
            this.pageBlockData1 = this.blockData1.slice(
              0,
              this.block1Index + 1
            );
            this.block1Index++;
            this.heightCheck();
          }
        } else if (this.pageBlockData2.length < this.blockData2.length) {
          let mainContentArea =
            this.getOffset(mutations[0].target).top +
            mutations[0].target.offsetHeight;
          if (mainContentArea < window.innerHeight) {
            //this.incrementBlockDataValue();
            this.pageBlockData2 = this.blockData2.slice(
              0,
              this.block2Index + 1
            );
            this.block2Index++;
            this.heightCheck();
          }
        } else {
          let mainContentArea =
            this.getOffset(mutations[0].target).top +
            mutations[0].target.offsetHeight;
          if (mainContentArea < window.innerHeight) {
            //this.incrementBlockDataValue();
            this.pageBlockData3 = this.blockData3.slice(
              0,
              this.block3Index + 1
            );
            this.block3Index++;
            this.heightCheck();
          }
        }
      }
    },
    // Infinite scroll load more
    loadMore: function () {
      if (
        this.pageBlockData1.length < this.blockData1.length ||
        this.pageBlockData2.length < this.blockData2.length ||
        this.pageBlockData3.length < this.blockData3.length
      ) {
        this.busy = true;
        //this.incrementBlockDataValue();
        if (this.pageBlockData1.length < this.blockData1.length) {
          this.pageBlockData1 = this.blockData1.slice(0, this.block1Index + 1);
          this.block1Index++;
        } else if (this.pageBlockData2.length < this.blockData2.length) {
          this.pageBlockData2 = this.blockData2.slice(0, this.block2Index + 1);
          this.block2Index++;
        } else {
          this.pageBlockData3 = this.blockData3.slice(0, this.block3Index + 1);
          this.block3Index++;
        }
        //this.heightCheck();
        this.busy = false;
      }
    },
    incrementBlockDataValue: function () {
      this.blockData = this.pageData.slice(0, this.blockDataIndex + 1);
      this.blockDataIndex++;
    },
    itemFAQ: function (data) {
      let FAQitems = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({ id, title, content, is_active });
      });
      return FAQitems;
    },
    getBonusShowHide: function (partner) {
      let hideBonus = this.getCASToplistShowHideData(partner);
      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
  },
  created: function () {
    if (
      this.$root.routes_meta[this.$route.params.postSlug] &&
      this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );
  },
  mounted: function () {
    if (this.aboutUsData != undefined) {
      this.blockData1 = [];
      this.blockData3 = [];
      const res_data = this.aboutUsData;
      this.blockData2 = res_data.content.blocks;
      Object.keys(res_data.meta).forEach((key) => {
        if (
          key != "more_payment_method" &&
          key != "teams_section" &&
          key != "timeline_section"
        )
          this.blockData1.push({
            blockName: key,
            data: res_data.meta[key],
          });
      });

      Object.keys(res_data.meta).forEach((key1) => {
        if (key1 === "teams_section" || key1 === "timeline_section")
          this.blockData3.push({
            blockName: key1,
            data: res_data.meta[key1],
          });
      });

      // Assets Sizes
      this.assets_images =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";

      // More Payments Bottom Card
      this.morePaymentBottom = res_data.meta.more_payment_method;

      // Author Blocks Filtered
      let atBlock = this.blockData2.filter((ele) => {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0)
        this.auhtorBlockdata = atBlock.shift().filtered_content;

      // RightContent Blocks Filtered
      let rightBlock = res_data.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0)
        this.rightBlockdata = rightBlock.shift().filtered_content;

      // Breadcrumb
      this.breadcrumb = res_data.breadcrumb;

      // Adminbar Data
      this.$root.adminBarData =
        Object.keys(res_data.toolbar).length > 0 ? res_data.toolbar : "";
      this.$root.disable = this.$root.adminBarData
        ? this.$root.adminBarData.visible
        : false;

      // if (!this.$root.enable_lazyload) {
      this.pageBlockData1 = this.blockData1;
      this.pageBlockData2 = this.blockData2;
      this.pageBlockData3 = this.blockData3;
      this.$root.show_footer = true;
      // } else {
      // if (Object.keys(this.blockData1).length > 0) {
      //   this.pageBlockData1.push(this.blockData1[this.block1Index]);
      //   this.block1Index++;
      //   this.$root.show_footer = false;
      // } else {
      //   this.$root.show_footer = true;
      // }
      //}

      // Schema Append
      document.getElementById("schema-script").innerHTML = res_data.schema;

      //this.getBonusShowHide(this.top_section);
    } else {
      this.$root.loading = true;
      this.getPageData();
    }
    if (
      this.scriptFlag === 0 &&
      this.pageBlockData2.filter((ele) => {
        return (
          ele.blockName === "wpvcb/custom-youtube" ||
          ele.blockName === "wpvcb/youtube-film-strip"
        );
      }).length > 0
    ) {
      this.youtubeInit();
      this.scriptFlag++;
    }
    this.$nextTick(() => this.heightCheck());
    var that = this;
    window.addEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.addEventListener("resize", () => {
      that.heightCheck();
    });
  },
  beforeDestroy: function () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    window.removeEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.removeEventListener("resize", () => {
      that.heightCheck();
    });
  },
  watch: {
    "$route.params.postSlug": function () {
      if (this.softwareProviderData != undefined) {
      } else {
        this.$root.loading = true;
        this.getPageData();
      }
    },
    blockData: function () {
      if (this.blockData.length === this.pageData.length) {
        this.$root.show_footer = true;
      }
    },
    pageBlockData1: function () {
      if (
        this.pageBlockData1.length === this.blockData1.length &&
        this.pageBlockData2.length === this.blockData2.length
      ) {
        this.$root.show_footer = true;
      }
    },
    pageBlockData2: function () {
      if (
        this.pageBlockData1.length === this.blockData1.length &&
        this.pageBlockData2.length === this.blockData2.length
      ) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.banner-section {
  position: relative;
  padding: 0 0 45px;
  .img-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  &-content {
    padding: 15px 0 10px;
    @media (min-width: @sizes[small]) {
      padding: 45px 0;
    }
    @media (min-width: @sizes[medium]) {
      padding: 20px 0;
    }
    @media (min-width: @sizes[large]) {
      padding: 30px 0;
    }
    @media (min-width: @sizes[md-large]) {
      padding: 50px 0;
    }
    .text_content {
      max-width: 665px;
      text-align: center;
      margin: 0 auto;
      label {
        font-family: Helvetica;
        font-style: normal;
        font-weight: 300;
        font-size: 28px;
        line-height: 36px;
        color: @white;
        margin: 0;
        @media (min-width: @sizes[medium]) {
          font-size: 36px;
          line-height: 48px;
        }
        @media (min-width: @sizes[large]) {
          font-size: 42px;
          line-height: 54px;
        }
        @media (min-width: @sizes[md-large]) {
          font-size: 48px;
          line-height: 62px;
        }
      }
    }
  }
}
.values-section {
  padding: 32px 0;
  background: @light-gray;
  @media (min-width: @sizes[sm-large]) {
    padding: 64px 0;
  }
  .values-header {
    border-bottom: 1px solid #bdbdbe;
    font-family: Helvetica;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: #222222;
    padding-bottom: 16px;
    margin-bottom: 32px;
    @media (min-width: @sizes[medium]) {
      font-size: 28px;
      line-height: 32px;
    }
    @media (min-width: @sizes[large]) {
      margin-bottom: 48px;
    }
  }
  .values-blocks {
    &-item {
      max-width: 322px;
      margin: 0 auto 35px;
      @media (min-width: @sizes[medium]) {
        margin: 0 auto;
      }
      .value-icon {
        display: block;
        min-height: 150px;
        margin-bottom: 32px;
      }
      h2 {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 22px;
        line-height: 25px;
        color: #222222;
        margin-bottom: 8px;
        @media (min-width: @sizes[medium]) {
          font-size: 28px;
          line-height: 32px;
          margin-bottom: 16px;
        }
      }
      p {
        font-family: Helvetica;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
        color: #222222;
        margin: 0;
      }
    }
  }
}
.fundamental-section {
  background: #f7d42b;
  position: relative;
  padding: 32px 0;
  @media (min-width: @sizes[sm-large]) {
    padding: 67px 0;
  }
  .fundamental-img-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  .fundamental-block {
    .display-flex();
    .justify-content-center();
    .flex-direction-column();
    max-width: 805px;
    margin: 0 auto;
    @media (min-width: @sizes[medium]) {
      .flex-direction-row();
    }
    &-logo {
      width: 239px;
      min-width: 239px;
      margin: 0 auto 64px;
      @media (min-width: @sizes[medium]) {
        margin: auto;
      }
    }
    &-cont {
      padding-left: 0px;
      @media (min-width: @sizes[medium]) {
        padding-left: 55px;
      }
      @media (min-width: @sizes[large]) {
        padding-left: 105px;
      }
      .header {
        border-bottom: 1px solid rgba(34, 34, 34, 0.2);
        font-family: Helvetica;
        font-weight: bold;
        font-size: 22px;
        line-height: 25px;
        color: #222222;
        padding-bottom: 16px;
        margin-bottom: 32px;
        @media (min-width: @sizes[medium]) {
          font-size: 28px;
          line-height: 32px;
        }
      }
      ul {
        li {
          margin-bottom: 16px;
          font-family: Helvetica;
          font-weight: normal;
          font-size: 16px;
          line-height: 26px;
          color: #222222;
          padding-left: 42px;
          background: url("") no-repeat left 0;
          background-size: 27px 26px;
        }
      }
    }
  }
}
.team-section {
  background: @light-gray;
  padding: 0 0 32px;
  @media (min-width: @sizes[sm-large]) {
    padding: 0 0 64px;
  }
  .team-header {
    border-bottom: 1px solid #bdbdbe;
    font-family: Helvetica;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: #222222;
    padding-bottom: 16px;
    margin-bottom: 32px;
    @media (min-width: @sizes[medium]) {
      font-size: 28px;
      line-height: 32px;
    }
    @media (min-width: @sizes[large]) {
      margin-bottom: 48px;
    }
  }
  .team-blocks {
    .display-flex();
    .flex-wrap(wrap);
    .justify-content-flex-start();
    margin: 0;
    @media (min-width: @sizes[small]) {
      margin: 0 -1%;
    }
    @media (min-width: @sizes[medium]) {
      margin: 0 -1% -16px;
    }
    .team-item {
      background: @white;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
      .border-radius(10px);
      padding: 16px;
      margin: 0 8px 16px;
      margin: 0 0 16px;
      width: 100%;
      max-width: none;
      @media (min-width: @sizes[small]) {
        margin: 0 1% 16px;
        width: 48%;
      }
      @media (min-width: @sizes[medium]) {
        width: 32%;
        max-width: 298px;
      }
      @media (min-width: @sizes[large]) {
        width: 23%;
      }
      .team-pic {
        .border-radius(10px);
        overflow: hidden;
        height: auto;
        margin-bottom: 24px;
        @media (min-width: @sizes[small]) {
          height: 261px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          .border-radius(10px);
        }
      }
      .tm-title {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 22px;
        line-height: 25px;
        color: #222222;
        margin-bottom: 8px;
      }
      .department {
        font-family: Helvetica;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
        color: #222222;
        margin: 0;
      }
    }
  }
}
.timeline-section {
  background: #222222;
  padding: 32px 0 74px;
  @media (min-width: @sizes[sm-large]) {
    padding: 64px 0 100px;
  }
  .timeline-header {
    border-bottom: 1px solid #bdbdbe;
    font-family: Helvetica;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: @white;
    padding-bottom: 16px;
    margin-bottom: 32px;
    @media (min-width: @sizes[medium]) {
      font-size: 28px;
      line-height: 32px;
    }
    @media (min-width: @sizes[large]) {
      margin-bottom: 48px;
    }
  }
}
.timeline-block {
  width: 100%;
  max-width: 788px;
  margin: 0 auto;
  position: relative;
  padding-left: 20px;
  @media (min-width: @sizes[md-medium]) {
    padding-left: 0px;
  }
  &:after {
    width: 3px;
    height: 100%;
    position: absolute;
    background: #f1f2f3;
    top: 0;
    left: 20px;
    content: "";
    transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    @media (min-width: @sizes[md-medium]) {
      left: 50%;
    }
  }
  &:before {
    width: 31px;
    height: 31px;
    background: transparent;
    border: 3px solid #f1f2f3;
    content: "";
    position: absolute;
    bottom: -35px;
    left: 0px;
    border-radius: 50%;
    @media (min-width: @sizes[md-medium]) {
      left: 50%;
      transform: translateX(-50%);
      -o-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      -moz-transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
    }
  }
  li {
    width: 100%;
    color: #fff;
    position: relative;
    z-index: 2;
    padding-bottom: 48px;
    @media (min-width: @sizes[md-medium]) {
      width: 50%;
    }
    &:after {
      width: 31px;
      height: 31px;
      background: var(--li-color);
      border: 3px solid var(--primary-color);
      content: "";
      position: absolute;
      top: -5px;
      left: -18.5px;
      border-radius: 50%;
    }
    &:before {
      width: 3px;
      height: 100%;
      position: absolute;
      background: var(--li-color);
      top: 0;
      left: 0;
      content: "";
      transform: translateX(-50%);
      -o-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      -moz-transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
    }
    &:nth-child(2n + 1) {
      margin-left: auto;
      padding-left: 24px;
    }
    &:nth-child(2n + 2) {
      padding-right: 0;
      padding-left: 24px;
      text-align: left;
      @media (min-width: @sizes[md-medium]) {
        padding-right: 24px;
        text-align: right;
      }
      &:after {
        left: -18.5px;
        right: auto;
        @media (min-width: @sizes[md-medium]) {
          left: auto;
          right: -18.5px;
        }
      }
      &::before {
        left: 0px;
        right: auto;
        @media (min-width: @sizes[md-medium]) {
          left: auto;
          right: -3px;
        }
      }
    }
    &:last-child {
      padding-bottom: 15px;
      @media (min-width: @sizes[md-medium]) {
        padding-bottom: 10px;
      }
      &:before {
        background: #f1f2f3;
      }
    }
    .date {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 16px;
      line-height: 26px;
      color: #ffd03a;
      display: block;
      margin-bottom: 11px;
    }
    h4 {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 22px;
      line-height: 25px;
      color: @white;
      margin-bottom: 16px;
    }
    p {
      font-family: Helvetica;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      color: @white;
      margin-bottom: 0px;
    }
  }
}

.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    font-size: 16px;
    line-height: 150%;
    padding: 8px;
    @media (min-width: @sizes[small]) {
      font-size: 28px;
    }
  }
}

.stripe {
  //display: block !important;
  text-align: center;
  p {
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
  }
}

.stripe {
  position: absolute;
  width: 100%;
  height: 20px;
  bottom: 0;
  top: 50%;
  transform: translateY(27px);
  left: 0;
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: @yellow;
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
  img {
    width: 18px !important;
    height: 14px !important;
    border-radius: 0 !important;
    object-fit: contain !important;
  }
  svg,
  img {
    display: block;
    margin: 3px auto;
    width: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue